import EnvEnum from '@constants/enums/env';

import config from '@/config';

export const isLocal = () => {
    return config.APP_ENV === EnvEnum.LOCAL;
};

export const isStaging = () => {
    return config.APP_ENV === EnvEnum.STAGING;
};

export const isLive = () => {
    return config.APP_ENV === EnvEnum.LIVE;
};
